import AdminLayout from '@/views/adminLayout/AdminLayout'

export default [
  {
    path: '/admin',
    component: AdminLayout,
    name: 'adminPage',
    meta: { title: '系统管理' },
    redirect: '/admin/user',
    isShow() {
      return false
    },
    children: [
      {
        path: 'user',
        name: 'userList',
        isShow() {
          return true
        },
        component: () => import(/* webpackChunkName: "userManager" */ '@/views/user/list'),
        meta: { title: '用户管理' }
      },
      {
        path: 'group',
        name: 'userGroupList',
        isShow() {
          return true
        },
        component: () => import(/* webpackChunkName: "userGroupManager" */ '@/views/userGroup/list'),
        meta: { title: '用户组管理' }
      },
      {
        path: 'markdown',
        name: 'markdownList',
        isShow() {
          return true
        },
        component: () => import(/* webpackChunkName: "markdownManager" */ '@/views/markdown/list'),
        meta: { title: 'markdown文档管理' }
      }
    ]
  }
]
